export const version = '1.1.8-alpha.5'
